<template>
  <div class="separator" :class="{ big: big }" :style="styles" />
</template>

<style lang="scss" scoped>
@import "../styles/global.scss";
.separator {
  background-image: url("../assets/ui-small-separator.png");
  width: 50%;
  height: 0.75em;

  @media (min-width: $tablet-min-width) {
    height: 0.5em;
  }

  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;

  &.big {
    background-image: url("../assets/ui-big-separator.png");
    height: 1em;
    margin: 4em 0;
  }
}
</style>

<script>
export default {
  props: ["big", "margin"],
  computed: {
    styles: function () {
      return {
        margin: `${this.margin} 0`,
      };
    },
  },
};
</script>